const filters = {
  numeric: '0123456789',
  cep: '0123456789-',
  alpha: 'ABCDEFGHIJKLMNOPQRSTUVXZWYabcdefghijklmnopqrstuvxzwy ',
  utf8: 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ '
}

filters.text = filters.alpha + filters.utf8
filters.alphanumeric = filters.text + filters.numeric

export default filters
